export default __webpack_public_path__ + "static/media/noImage.3106f75d.png";